import { isLoaderError } from 'react-loosely-lazy';
import { useFlagsService } from '@atlassian/jira-flags';
import { toFlagId } from '@atlassian/jira-flags/src/services/types';
import message from './messages';

export const ChunkLoadErrorFlag = ({ error }: { error: Error }) => {
	const flagKey = toFlagId('chunk-load-error');
	const { showFlag, dismissFlag } = useFlagsService();

	if (isLoaderError(error)) {
		showFlag({
			id: flagKey,
			key: flagKey,
			type: 'error',
			title: message.title,
			description: message.description,
			isAutoDismiss: true,
			actions: [
				{
					content: message.refreshPageButton,
					onClick: () => {
						dismissFlag(flagKey);
						window.location.reload();
					},
				},
			],
		});
	}

	return null;
};
